import { formatDescription } from 'core/presenters/stopPresenter'
import { formatDate, parseISO } from 'core/utils/date'

import formatZonedDate from 'legacy/utils/date/formatZonedDate'

import { type Stop, type StopCheckType } from '../domain/Shipment'

export function getFormattedStops(stops: Stop[]) {
  return stops.map(formatDescription).join(' → ')
}

export function getCheckedAt(checkedAt?: string, timezone?: string) {
  return checkedAt ? formatZonedDate(new Date(checkedAt), timezone, 'MMM d, h:mm a') : 'Pending'
}

export function getStopCheckTitle(type: StopCheckType) {
  return type === 'in' ? 'Arrived' : 'Departed'
}

export function getStopCheckClassName(type: StopCheckType) {
  return type === 'in' ? 'is-checkin' : 'is-checkout'
}

export function getStopCheckIsCurrent(
  type: StopCheckType,
  stopState: {
    index: number
    checkIn?: string
    checkOut?: string
  }
) {
  return type === 'in' ? stopState.checkIn : stopState.checkOut
}

export function getStopCheckInfo(stop: Stop, type: StopCheckType) {
  return type === 'in' ? stop?.checkInAt : stop?.checkOutAt
}

export function getStopCheckButtonLabel(type: StopCheckType) {
  return type === 'in' ? 'Driver arrived at facility' : 'Driver left the facility'
}

export function getPreviousDateTime(
  previousDateTime: string,
  format: string,
  timeZone?: string | null
) {
  const date = previousDateTime ? parseISO(previousDateTime) : new Date()

  return formatDate(date, format, timeZone ?? undefined)
}

export function getFormattedStopDate(stop: Stop) {
  return formatZonedDate(stop.date, stop.timezone, 'EEEE, d MMMM')
}

export function getFormattedCity(stop: Stop) {
  return `${stop.city}, ${stop.state} ${stop.zipcode}, ${stop.country}`
}

export function getContactName(stop: Stop) {
  return stop.contact?.name ? stop.contact.name : '-'
}

export function formatStopLabel(stop: Stop): string {
  const facilityName = stop.facility?.companyName || stop.facility?.warehouseName
  const address = stop.address
  const location = facilityName || address || `${stop.city}, ${stop.state}`
  return location
}
